import { render, staticRenderFns } from "./InventoryWidget.vue?vue&type=template&id=797c605a&"
import script from "./InventoryWidget.vue?vue&type=script&lang=js&"
export * from "./InventoryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports